import { PostHogProvider as PostHogProviderJs } from 'posthog-js/react';

const PostHogProvider = ({ children }: { children: React.ReactNode }) => (
  <PostHogProviderJs
    apiKey={process.env.VITE_PUBLIC_POSTHOG_KEY ?? ''}
    options={{
      api_host: process.env.VITE_PUBLIC_POSTHOG_HOST,
      debug: process.env.NODE_ENV === process.env.DEV
    }}
  >
    {children}
  </PostHogProviderJs>
);

export default PostHogProvider;
